module.exports = __webpack_public_path__ + "img/sectors-img03.8bce1524.jpg";